import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { RerunEventRollupsDocument } from './rerun-rollups.generated';

export const useRerunEventRollups = (
  options: ApiOptions<typeof RerunEventRollupsDocument> = {},
) => {
  const { t } = useTranslation();
  return useMutation(RerunEventRollupsDocument, {
    ...useNotifications(RerunEventRollupsDocument, {
      failure: t('api.common.error_generic'),
      success: t('api.events.rerun_rollups_success'),
    }),
    ...options,
  });
};
